import axios from 'axios'
import { Loading} from 'element-ui'
import loadingGif from '../assets/loading.gif'
var loading
const instance = axios.create({
    // 接口基础地址  接口的公共地址 一般域名
    // baseURL:'',
    // 超时时间

    // timeout:5000
})
// 请求拦截器
instance.interceptors.request.use(cfg => {
     // 在请求头中添加 token
    if (localStorage.getItem('token')) {
        cfg.headers['token'] = localStorage.getItem('token');
         //cfg.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    }else{
        // alert('未登录，请登录！')
        // location.href = '/login'
    }
    // 封装请求加载状态
    // loading = Loading.service({
    //     lock: true, 
    //     background: 'rgba(0, 0, 0, 0.7)',
    //     text: "loading...",
    //     spinner: loadingGif,
    // });
    // config.loading = true
    // config.loadingImage = require('../assets/loading.gif') 
    return cfg
},error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(res => {
    if(res.data.code === 400){
        alert(res.data.message)
        // this.$message.error(res.data.message);
        location.href = '/login'
        localStorage.clear();
    }
    setTimeout(() => {
        // 请求加载状态停止
        // loading.close()
    }, 700)

    return res
})

export default instance